import {
  action,
  autorun,
  computed,
  makeObservable,
  observable,
  runInAction,
  toJS,
} from 'mobx'
import {AuthService as Service} from 'rest'
import {cookies} from 'rest/helpers/cookies'
import {Stores} from './index'
import jwt_decode from 'jwt-decode'
import {UserForLoginDto} from 'rest/models/UserForLoginDto'
import {UserForRegisterDto} from 'rest/models/UserForRegisterDto'
import {AccessToken} from 'rest/models/AccessToken'
import {OpenAPICouponCenter} from 'rest/core/OpenAPI'
import cookie from 'react-cookies'
import {Dispatch, SetStateAction} from 'react'
export class AuthStore {
  stores: Stores
  authenticated: boolean
  _me: any

  constructor(stores: Stores) {
    this.stores = stores
    autorun(() => {
      this.authenticated = !!cookies.get('access')
      this._me = this.authenticated ? jwt_decode(cookies.get('access')) : null
    })
    makeObservable(this, {
      _me: observable,
      me: computed,
      authenticated: observable,
      // handleAuth: action,
      signOut: action,
      saveTokens: action,
    })
  }

  get me() {
    return toJS(this._me)
  }

  login = async (
    data: UserForLoginDto,
    setUser: Dispatch<SetStateAction<Record<string, any>>>
  ) => {
    try {
      const res = await Service.postApiAuthLogin({
        ...data,
        siteId: 8,
      })

      setUser(res.data)
      return await this.saveTokens(res.data)
    } catch (err) {
      return err
    }
  }

  register = async (
    data: UserForRegisterDto,
    setUser: Dispatch<SetStateAction<Record<string, any>>>
  ) => {
    try {
      const res = await Service.postApiAuthRegister({
        ...data,
        siteId: 2,
        type: 2,
      })
      setUser(res.data)
      return await this.saveTokens(res.data)
    } catch (err) {
      return err
    }
  }

  signOut = async () => {
    localStorage.clear()
    cookies.removeAll()
    this.authenticated = !!cookies.get('access')
    runInAction(() => {
      this._me = null
    })
  }

  saveTokens = async (tokens: AccessToken) => {
    const {token, refresh, expiration} = tokens
    try {
      const expires = new Date(expiration)
      if (token) {
        // @ts-ignore
        //let data = jwt_decode(token || '')
        cookies.set('access', token, expires)
        OpenAPICouponCenter.TOKEN = token
      }

      if (refresh) {
        // @ts-ignore
        // let { ttl } = jwt_decode(refresh || '')
        cookies.set('refresh', refresh, expires)
      }

      const _cookies = cookie.loadAll()
      console.log('_cookies', _cookies)

      this.authenticated = !!token
      this._me = jwt_decode(token)

      localStorage.setItem('user', JSON.stringify(tokens))
    } catch (err) {
      console.log('err', err)
      this.stores.ErrorStore.handle(err)
      console.error(err)
    }
  }
}
